// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorHeader-cls1_k9K","cls2":"AuthorHeader-cls2_MD9 AuthorHeader-cls1_k9K"};